export default __webpack_public_path__ + "static/media/Reportes.569a7b0a.png";